// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1ckO7","alert":"SettungsInbox_alert__2SiNp"};